import { render, html } from "lit-html";
import { classMap } from "lit-html/directives/class-map.js";
import { styleMap } from "lit-html/directives/style-map.js";
import { repeat } from "lit-html/directives/repeat.js";
import connect from "@escapio/shared/data-store/connect";
import {
	ACTION_SET_CLASSIFICATION_FILTER,
	ACTION_RESET_CLASSIFICATION_FILTER,
	store,
} from "./DataStore";
import { translate } from "@escapio/shared/l10n/translate";
import { track } from "@escapio/portal/tracker/EventTracker";
import { debounce } from "@escapio/shared/event/debounce";
import {
	ALL,
	SHORT_LABELS,
	LONG_LABELS,
	OPTIONS,
	TRACKING_LABELS,
	isAtLeast,
} from "@escapio/portal/components/classification";
import { data } from "@escapio/shared/state/payload";

customElements.define(
	"esc-hotel-list-classification-filter",
	class extends connect(HTMLElement, store) {
		constructor() {
			super();
			this.classification = ALL;
			this.availableOptions = null;
			this.hotelCountPerClassification = null;
			this.debouncedDispatch = debounce(300, this.notifyStore.bind(this));
		}

		update(state, { counters }) {
			this.classification = state.filters.classification;
			this.hotelCountPerClassification = counters.classification;
			this.availableOptions = Object.keys(OPTIONS).filter(
				key => this.hotelCountPerClassification[key] > 0,
			);

			this.render();
		}

		render() {
			// Hide on 4/5-star hotel type related pages.
			if ([306, 307].includes(data.preselectedHotelType)) {
				this.style.display = "none";
				return;
			}

			const sliderWidthClasses = {
				"slider--1-of-4-ticks-active": this.availableOptions.length <= 1,
				"slider--2-of-4-ticks-active": this.availableOptions.length == 2,
				"slider--3-of-4-ticks-active": this.availableOptions.length == 3,
			};
			const value = this.availableOptions.indexOf(this.classification);
			const sliderStyle = {
				"--esc-slider-progress": `${
					value > 0 ? (value * 100) / (this.availableOptions.length - 1) : 0
				}%`,
			};

			const template = html`<label>
				<div class="slider-label filter-box__section-title">
					${translate("filter_classification_label")}
					<span
						class="slider-label__value ${classMap({
							"slider-label__value--active": this.classification != ALL,
						})}"
					>
						${LONG_LABELS[this.classification]}
					</span>
				</div>
				<div class="slider-container">
					<input
						class="slider slider--inverted-track ${classMap(
							sliderWidthClasses,
						)}"
						type="range"
						min="0"
						max=${this.availableOptions.length - 1}
						step="1"
						style=${styleMap(sliderStyle)}
						.value=${value}
						@input=${this.onInput}
						@change=${this.onChange}
					/>
					<div class="slider__disabled-part"></div>
					<div class="slider__rule">
						${repeat(
							Object.keys(OPTIONS),
							key => key,
							key => html`
								<div class="slider__rule__label">
									<div>
										<span class="classification-filter-label"
											><i
												class="star-icon classification-filter-star ${classMap({
													"classification-filter-star--active":
														this.hotelCountPerClassification[key] &&
														isAtLeast(this.classification, OPTIONS[key]),
												})}"
											></i>
											${SHORT_LABELS[key]}
										</span>
										<span class="filter-hotel-count"
											>${this.hotelCountPerClassification[key]}</span
										>
									</div>
								</div>
							`,
						)}
					</div>
				</div>
			</label>`;
			render(template, this, { host: this });
		}

		onInput({ target }) {
			this.classification = Object.keys(OPTIONS)[target.value];
			this.render();
			this.debouncedDispatch();
		}

		onChange() {
			track(
				"Filter",
				"Klassifizierung Filter",
				`${TRACKING_LABELS[this.classification]}${this.trackLabelSuffix}`,
			);
		}

		notifyStore() {
			if (this.classification) {
				this.dispatchAction(
					ACTION_SET_CLASSIFICATION_FILTER,
					this.classification,
				);
			} else {
				this.dispatchAction(ACTION_RESET_CLASSIFICATION_FILTER);
			}
		}

		get trackLabelSuffix() {
			return this.getAttribute("track-label-suffix") || "";
		}
	},
);
